import React from 'react';
import { connect } from 'react-redux';
import { getCurrentLocale } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContainer = styled.div`
  padding: 15px 30px;
  background-color: ${(props) => props.bannerColor || colors.BANNER_GREEN};
  color: white;
  font-size: 18px;
  font-family: Circular-Bold;
  text-align: center;
`;

const BannerMessage = ({ bannerMessage }) => {
  if (!bannerMessage) return null;
  return (
    <StyledContainer bannerColor={bannerMessage['color']}>
      {bannerMessage[getCurrentLocale()]}
    </StyledContainer>
  );
};

const mapStoreToProps = (store) => ({
  bannerMessage: store.dashboard.bannerMessage,
});

const mapDispatchToProps = {};

BannerMessage.propTypes = {
  bannerMessage: PropTypes.string,
};

export default connect(mapStoreToProps, mapDispatchToProps)(BannerMessage);
